;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import { Row, Col, Button } from 'reactstrap';
import Link from 'next/link';
import { MdChevronRight } from 'react-icons/md';
import { useParams } from 'next/navigation';
import NoJobmatches from '../svg/NoJobmatches';
import { useUser } from '../../contexts/UserContext';
import { Dictionaries } from '../../i18n/i18n-config';
import { getI18nUtils } from '../../i18n/i18n-utils';

type Props = {
  onMobile?: boolean;
  className?: string;
  dictionary: Partial<Dictionaries>;
};

const JobmatchNoResults = ({ onMobile, className, dictionary }: Props): JSX.Element => {
  const { formatMessage } = getI18nUtils(dictionary);
  const { locale } = useParams();
  const user = useUser();
  const { acquaintanceFlowSkipped, jobPreferences } = user.candidate || {};

  const suggestAcquaintanceFlow = !acquaintanceFlowSkipped && !jobPreferences;

  const paragraph1Id = 'no_jobmatches_paragraph_1';
  const paragraph2Id = suggestAcquaintanceFlow ? 'no_jobmatches_acquaintance_paragraph_2' : 'no_jobmatches_paragraph_2';
  const buttonTextId = suggestAcquaintanceFlow ? 'complete-profile' : 'no_jobmatches_go_to_job_expectations';
  const linkHref = suggestAcquaintanceFlow
    ? `/${locale}/my-synergie?profileModal=true`
    : `/${locale}/my-synergie/profile/job-preferences`;

  const classes = `d-flex justify-content-center${className ? ` ${className}` : ''}`;

  return (
    <Row className={classes}>
      <Col xs={12} lg={{ size: 4, order: 2 }} className="d-flex justify-content-center my-5">
        <NoJobmatches height={onMobile ? 192 : 299} width={onMobile ? 198 : 289} />
      </Col>
      <Col
        xs={12}
        lg={{ size: 6, order: 1 }}
        className="d-flex flex-column justify-content-center align-items-start align-items-lg-start mb-5 mt-lg-5 px-4"
      >
        <h3 className="text-lg-nowrap mb-4">{formatMessage({ id: 'no_jobmatches' })}</h3>
        <p>
          {formatMessage({ id: paragraph1Id })} <br />
          {formatMessage({ id: paragraph2Id })}
        </p>
        <Row className="w-100">
          <Col xs={12} md={6}>
            <Link href={linkHref}>
              <Button className="d-flex justify-content-center align-items-center my-2 w- py-2 w-100" color="primary">
                {formatMessage({ id: buttonTextId })}
                <MdChevronRight size={16} className="ms-2" />
              </Button>
            </Link>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default JobmatchNoResults;
